<template>
  <el-dialog :title="$t('accountPay.title')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form label-width="120px">
      <h3>{{ $t('accountPay.bankInfo') }}</h3>
      <el-form-item :label="$t('accountPay.personName')">
        <el-input v-model="accountPayInfo.accountBank.personName" disabled />
      </el-form-item>
      <el-form-item :label="$t('accountPay.bankName')">
        <el-input v-model="accountPayInfo.accountBank.bankName" disabled />
      </el-form-item>
      <el-form-item :label="$t('accountPay.bankCode')">
        <el-input v-model="accountPayInfo.accountBank.bankCode" disabled />
      </el-form-item>

      <h3>{{ $t('accountPay.paymentInfo') }}</h3>
      <el-form-item :label="$t('accountPay.paymentStatus')" required>
        <el-select v-model="accountPayInfo.state" :placeholder="$t('accountPay.selectStatus')" style="width:100%">
          <el-option :label="$t('accountPay.approvePayment')" value="1100" />
          <el-option :label="$t('accountPay.rejectPayment')" value="1200" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('accountPay.reason')" required>
        <el-input type="textarea" :placeholder="$t('accountPay.reasonPlaceholder')" v-model="accountPayInfo.remark"
          :rows="3" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="_accountPaySubmit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryAccountBank } from '@/api/admin/accountWithdrawalApplyFkManage/accountWithdrawalApplyFkManageApi'

export default {
  name: 'AccountPay',
  data() {
    return {
      dialogVisible: false,
      accountPayInfo: {
        accountBank: {
          personName: '',
          bankName: '',
          bankCode: ''
        },
        state: '',
        remark: ''
      }
    }
  },
  watch: {
    'accountPayInfo.state'(val) {
      if (val === '1100') {
        this.accountPayInfo.remark = this.$t('accountPay.approve')
      } else {
        this.accountPayInfo.remark = ''
      }
    }
  },
  methods: {
    open(bankId) {
      this.queryAccountBank(bankId)
      this.dialogVisible = true
    },
    async queryAccountBank(bankId) {
      try {
        const res = await queryAccountBank({ bankId })
        if (res.data && res.data.length > 0) {
          this.accountPayInfo.accountBank = res.data[0]
        }
      } catch (error) {
        console.error('获取银行信息失败:', error)
      }
    },
    handleClose() {
      this.accountPayInfo = {
        accountBank: {
          personName: '',
          bankName: '',
          bankCode: ''
        },
        state: '',
        remark: ''
      }
    },
    _accountPaySubmit() {
      if (!this.validate()) {
        return
      }

      const data = {
        state: this.accountPayInfo.state,
        remark: this.accountPayInfo.remark
      }

      if (data.state === '1200') {
        data.remark = `${this.$t('accountPay.reject')}: ${data.remark}`
      }

      this.$emit('submit', data)
      this.dialogVisible = false
    },
    validate() {
      if (!this.accountPayInfo.state) {
        this.$message.error(this.$t('accountPay.statusRequired'))
        return false
      }
      if (!this.accountPayInfo.remark) {
        this.$message.error(this.$t('accountPay.reasonRequired'))
        return false
      }
      if (this.accountPayInfo.remark.length > 200) {
        this.$message.error(this.$t('accountPay.reasonMaxLength'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
h3 {
  margin: 20px 0;
}
</style>